import Choices from "choices.js";

const elements = Array.from(document.querySelectorAll(".js-choice"));

function init() {
    if (!elements.length) {
        return;
    }

    elements.forEach((el) => {
        const choice = new Choices(el, {
            searchEnabled: false,
            itemSelectText: "",
        });

        if (el.classList.contains("js-change-submit")) {
            choice.passedElement.element.addEventListener("choice", (e) => {
                const href = new URL(window.location);
                const limit = e.detail.choice.value;
                href.searchParams.set(
                    el.getAttribute("name"),
                    limit
                );
                window.location = href;
            });
        }
    });
}

init();
